// extracted by mini-css-extract-plugin
module.exports = {"avatar_container":"setavatar_avatar_container__1Lfgm"};